import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'
import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

const watchEntityKeys = ['contracts']

function useContracts(options = {}){
  const { entityKey, filters, performHttpRequests } = options
  const { owner_id: filterOwnerId, owner_type: filterOwnerType } = filters

  const {
    updatedEntities: { contracts: contractsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const contracts = useSelector(reduxState => reduxState.entities.contracts)

  const filteredContracts = useMemo(() => {
    const filtered = Object.values(contracts).filter((contract) => {
      const { owner_id, owner_type } = contract

      const matchOwnerId = matchFilterNumber(owner_id, filterOwnerId)
      const matchOwnerType = filterOwnerType ? owner_type === filterOwnerType : true

      return matchOwnerId && matchOwnerType
    })

    return sortArrayBy(filtered, 'desc', 'id')
  }, [contractsUpdatedAt, JSON.stringify(options)])

  const hasFilteredContracts = !!filteredContracts.length

  const { loading: loadingContracts } = useReduxAction(
    'contracts',
    'loadContracts',
    {
      entityKey,
      ...defaultRequestOptions.contract,
      ...filters,
    },
    [performHttpRequests, filters],
    {
      shouldPerformFn: ({ loaded, loading }) => performHttpRequests && !loaded && !loading,
    },
  )

  return {
    filteredContracts,
    hasFilteredContracts,
    loading: loadingContracts,
  }
}

export default useContracts
